<template>
	<div class="playback">
		<div class="playback-item" v-for="(item,index) in playbackData" :key="index"  @click="goLiveDetail(item)">
			<div class="item-content">
				<div class="sub_size">
					<img :src="item.lvrrSmallImg" alt="">
				</div>
				<div class="sub_001">
					<div class="bian_01">
            <span>{{ item.lvrrTitle }}</span>
          </div>
					<div class="bian_02">
						<span>
							热度：
							<span>{{ item.hotNum }}</span>
						</span>
						<span>
							{{ item.lvrrDiffTime }}
						</span>
					</div>

				</div>
				<div class="sub_cover">
					<!-- <img src="../../assets/img/bull_class/fufei_2x.png" alt="" class="fu_fei"> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name:"playBack",
		data(){
			return {
				buyCardShow:false,
			}
		},
		props: {
			playbackData: {
				type:Array,
			},
			getLiveDetail: {
			  type: Function,
			  default: null,
			},
		},
		components:{
		},
		methods:{
			goLiveDetail(item){
				// console.log('点击回放',item);
				//传递参数到父组件
				// this.$emit('getLiveDetail',item);

				//判断权限
				if(item.lockStatus == 1){
					this.$message.error('暂无观看权限');return false;
				}

				//有，去回放详情
				this.$router.push({name:"livePlayback",query:{lvrrId:item.lvrrId}});
			},
		}
	}
</script>

<style scoped>
	.playback{
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.playback .playback-item {
		width: 650px;
		height: 220px;
		background-color: #FFFFFF;
		margin-bottom: 15px;
		cursor: pointer;
		position: relative;
		border-radius: 12px;
	}

	.playback-item .item-content{
		display: flex;
	}

	.playback-item .item-content .sub_cover{
		position: absolute;
		right: -1.5625rem;
		top: 0;
	}

	.sub_size {
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
	}

	.sub_size img{
		width: 184px;
		height: 184px;
		margin-top: 18px;
		margin-left: 24px;
		margin-bottom: 18px;
		border-radius: 8px;
	}

	.sub_001 {
		margin-left: 10px;
	}

	.sub_001 .bian_01{
		height: 33px;
		margin-top: 54px;
		margin-bottom: 86px;
		font-size: 24px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #222222;
	}
  .sub_001 .bian_01>span{
    word-break: break-word;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:3;
  }

	.sub_001 .bian_02{
		width: 380px;
		display: flex;
		justify-content: space-between;
	}

	.fu_fei {
		width: 50%;
	}
	img {
		display: block;
		margin: auto;
	}

	.sub_001 p:nth-child(1) {
		overflow: hidden;
		text-align: left;
		font-size: 24px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #222222;
		line-height: 2.0625rem;
	}
	.sub_001 p:nth-child(2) {
		color: #666666;
		padding-bottom: 1.25rem;
		font-size: 18px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 25px;
	}
</style>



// WEBPACK FOOTER //
// src/components/common/playback.vue